"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateSortBySelector = void 0;
var Types_1 = require("@CommonFrontendBackend/Templates/Types");
var SortBySelector_1 = __importStar(require("Dashboard/SortBySelector/SortBySelector"));
var react_1 = __importDefault(require("react"));
var DashboardTypes_1 = require("Dashboard/DashboardTypes");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var TemplateSortBySelector = function (props) {
    var sortBy = props.sortBy, setSortBy = props.setSortBy, setSortDirection = props.setSortDirection, setPage = props.setPage, hideText = props.hideText, sortDirection = props.sortDirection;
    var setSortFilter = function (sortBy, sortDirection) {
        if (setPage) {
            setPage(Types_1.TEMPLATES_FIRST_PAGE);
        }
        setSortBy(fromMenuSortBy(sortBy));
        setSortDirection(fromMenuSortDirection(sortDirection));
    };
    return (react_1.default.createElement(SortBySelector_1.default, { menuAssets: templatesSortMenuAssets, selectedMenuItem: toSortMenuItem(sortBy), onSelectMenuItemHandle: setSortFilter, hideText: hideText, sortDirection: toMenuSortDirection(sortDirection) }));
};
exports.TemplateSortBySelector = TemplateSortBySelector;
var toSortMenuItem = function (sortBy) {
    switch (sortBy) {
        case Types_1.SortField.DateCreated:
            return SortBySelector_1.MenuItem.Created;
        case Types_1.SortField.LastEdited:
            return SortBySelector_1.MenuItem.Edited;
        case Types_1.SortField.Name:
            return SortBySelector_1.MenuItem.Name;
        default:
            throw new Error("Unhandled sort menu item");
    }
};
var fromMenuSortBy = function (sortBy) {
    switch (sortBy) {
        case DashboardTypes_1.SortBy.CreatedAt:
            return Types_1.SortField.DateCreated;
        case DashboardTypes_1.SortBy.LastEditedAt:
            return Types_1.SortField.LastEdited;
        case DashboardTypes_1.SortBy.Name:
            return Types_1.SortField.Name;
        default:
            throw new Error("Unhandled menu sort by");
    }
};
var fromMenuSortDirection = function (sortDirection) {
    switch (sortDirection) {
        case DashboardTypes_1.SortDirection.Ascending:
            return Types_1.SortDirection.Ascending;
        case DashboardTypes_1.SortDirection.Descending:
            return Types_1.SortDirection.Descending;
        default:
            throw new Error("Unhandled menu sort direction");
    }
};
var toMenuSortDirection = function (sortDirection) {
    switch (sortDirection) {
        case Types_1.SortDirection.Ascending:
            return DashboardTypes_1.SortDirection.Ascending;
        case Types_1.SortDirection.Descending:
            return DashboardTypes_1.SortDirection.Descending;
        default:
            throw new Error("Unhandled menu sort direction");
    }
};
var templatesSortMenuAssets = [
    {
        type: SortBySelector_1.MenuItem.Edited,
        text: "Last Edited",
        icon: react_1.default.createElement(icons_1.Edit, null),
        sortBy: DashboardTypes_1.SortBy.LastEditedAt,
    },
    {
        type: SortBySelector_1.MenuItem.Created,
        text: "Date Created",
        icon: react_1.default.createElement(icons_1.Clock, null),
        sortBy: DashboardTypes_1.SortBy.CreatedAt,
    },
    {
        type: SortBySelector_1.MenuItem.Name,
        text: "Alphabetical",
        icon: react_1.default.createElement(icons_1.Fonts, null),
        sortBy: DashboardTypes_1.SortBy.Name,
    },
];
